var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Plotly',{staticStyle:{"width":"100%"},attrs:{"display-mode-bar":false,"data":_vm.getChartData,"layout":_vm.getChartLayout}})
}
var staticRenderFns = []

export { render, staticRenderFns }